import { render, staticRenderFns } from "./TaskAdd.vue?vue&type=template&id=2f8ff959&"
import script from "./TaskAdd.vue?vue&type=script&lang=js&"
export * from "./TaskAdd.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports